export const URL_LESSONS = 'lessons';